import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

import { MentionsProviderQuery } from './MentionsProviderQuery.graphql.ts';
import type { MentionsProviderQuery as MentionsProviderQueryType } from './__types__/MentionsProviderQuery.ts';

export const fetchMentionsProviderData = async () => {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	return getApolloClient()
		.query<MentionsProviderQueryType>({
			query: MentionsProviderQuery,
		})
		.then(({ data }) => {
			return data;
		})
		.catch((error) => {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
			markErrorAsHandled(error);
			return undefined;
		});
};
